export default __webpack_public_path__ + "static/media/webapp.99fe2d4c.png";